var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DialogTile',{attrs:{"title":"Activate account"}},[_c('Notification',{attrs:{"type":_vm.n_type,"message":_vm.n_message}}),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Login now")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }